import React from "react";
import Layout from "../components/Layout";
import { useAuth } from "../lib/auth";
import AdminPaymentsPanel from "../components/AdminPaymentsPanel";
import PaymentsTab from "./profile-tabs/PaymentsTab";
import { Receipt } from "@phosphor-icons/react";

export default function Payments() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";

  return (
    <Layout>
      <div className="max-w-6xl mx-auto p-5 sm:p-8">
        <div className="mb-6 flex items-center gap-3">
          <Receipt size={26} weight="duotone" className="text-primary-app" />
          <div>
            <div className="text-[10px] uppercase tracking-[3px] text-muted">
              {isAdmin ? "Gestión de cobros" : "Tus comprobantes"}
            </div>
            <h1 className="font-display font-black uppercase text-3xl sm:text-4xl tracking-tighter">
              Pagos
            </h1>
          </div>
        </div>

        {isAdmin ? (
          <AdminPaymentsPanel />
        ) : (
          <PaymentsTab userId={user?.user_id} targetUser={user} />
        )}
      </div>
    </Layout>
  );
}
